<template>

    <div v-if="data" class="contentWrapper" v-bind:style="{ width: settings.width+'%' }">

        <div class="prop-wrap">

            <div :class="[{'bordered':  settings.isBordered }, 'prop-inner']">

                <!-- image -->
                <template v-if="contentElementData[3] && contentElementData[3].assets.length && contentElementData[3].assets[0].asset">
                    <img class="lazy-img-fadein is-pulled-left richTextImg" v-lazy="getAsset(contentElementData[3].assets[0].asset)" />
                </template>

                <!-- HEADER -->
                <div class="contentHeader">

                    <!-- title -->
                    <h1 class="title" v-if="contentElementData[0] && contentElementData[0].value">{{ contentElementData[0].value }}</h1>

                    <!-- leadin -->
                    <h2 class="subtitle" v-if="contentElementData[1] && contentElementData[1].value" v-html="contentElementData[1].value"></h2>

                </div>


                <!-- PRODUCT BOX -->
                <template v-if="contentElementData[4] && contentElementData[4].value != productBoxTypes.NONE.id">

                    <div class="productBox is-pulled-right">

                        <div class="productBoxHeader" v-if="contentElementData[5]">
                            <span>{{ contentElementData[5].value }}</span>
                        </div>

                        <div class="productBoxImage">

                            <img class="lazy-img-fadein" v-lazy="getProductBoxAsset(contentElementData[6].product.productAssets)" />

                        </div>

                        <span class="productBoxHeadline">{{ contentElementData[7].value }}</span>

                        <template v-if="contentElementData[4].value != productBoxTypes.LARGE.id">
                            <span class="productBoxTitle" v-html="contentElementData[6].product.displayName"></span>
                        </template>

                        <template v-if="contentElementData[4].value == productBoxTypes.MEDIUM.id || contentElementData[4].value == productBoxTypes.LARGE.id">

                            <!-- Large Product Box -->
                            <template v-if="contentElementData[4].value == productBoxTypes.LARGE.id">

                                <!-- product box text -->
                                <div class="productBoxText" v-if="contentElementData[8].value">
                                    {{ contentElementData[8].value }}
                                </div>

                            </template>

                            <!-- product name -->
                            <span class="productBoxTitle" v-html="contentElementData[6].product.displayName"></span>

                            <!-- product type -->
                            <div class="productBoxType" v-if="contentElementData[6].product.type">
                                <span>{{ getProductType }}</span>
                            </div>

                            <template v-else-if="contentElementData[4].value == productBoxTypes.MEDIUM.id">


                            </template>

                        </template>


                    </div>

                </template>


                <!-- BODY -->
                <div class="contentBody is-clearfix" v-if="contentElementData[2] && contentElementData[2].value" v-html="text">

                </div>


                <!-- FOOTER -->
                <div class="contentFooter">

                    <template v-if="contentElementData[4]">

                    </template>

                </div>

            </div>

        </div>

    </div>

</template>


<script>

export default {

    props: ['data', 'settings'],

    data(){
		return {
            contentElementData: []
		}
	},

    created() {

        this.contentElementData = this.data.contentElement.contentElementData;

    },

    mounted() {

        $('.contentWrapper').flowtype({
            minFont : 2,
            fontRatio: 20
        });
    },

    updated() {
        $('.contentWrapper').flowtype({
            minFont : 2,
            fontRatio: 20
        });
    },

    computed: {

        getImage() {
            return this.$config.assets + '/' + this.contentElementData[3].assets[0].asset.path + '/' + this.contentElementData[3].assets[0].asset.filename;
        },

        productBoxTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_BOX_TYPES')
        },

        productAssetTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
		},

        productTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_TYPES');
        },

        getProductType() {

            for (var key in this.productTypes) {
                if (this.productTypes.hasOwnProperty(key) && this.productTypes[key].id == parseInt(this.contentElementData[6].product.type)) {
                    this.productType = this.productTypes[key].name;
                    return this.$t('PRODUCT_TYPE-' + this.productTypes[key].name);
                }
            }
        },

        text() {

            return this.nl2br(this.contentElementData[2].value);

        }

    },

    methods: {



        getProductBoxAsset(assets) {

            var foundCoupons = [];
            var foundDefaults = [];

            if(assets !== undefined && assets.length > 0) {

                // Bei Coupon-Darstellung das Bild vom Typ „Coupon“ verwenden,
                // oder - wenn nicht vorhanden - das Bild mit Typ „Default“;
                for(var i = 0; i < assets.length; i++) {

                    if(assets[i].type == this.productAssetTypes.COUPON.id) {
                        foundCoupons.push(i);
                    }
                    else if(assets[i].type == this.productAssetTypes.DEFAULT.id) {
                        foundDefaults.push(i);
                    }
                }

            }

            if(foundDefaults.length > 0) {
                return this.$config.assets + assets[foundDefaults[0]].asset.path + "/" + assets[foundDefaults[0]].asset.filename;
            }
            if(foundCoupons.length > 0) {
                return this.$config.assets + assets[foundCoupons[0]].asset.path + "/" + assets[foundCoupons[0]].asset.filename;
            }

            return '';

        },

        getAsset(asset) {

            // return this.$config.assets + asset.path + '/' + asset.filename;
            var url = asset.filename;

            // get file extension
            var ext = url.split('.').pop();

            // check if we've an image
            if(ext == 'jpg' || ext == 'gif' || ext == 'png') {
                return this.$config.assets + asset.path + '/' + asset.filename;
            }

            // console.log(this.$config.assets + asset.path + '/' + asset.filename.substr(0, asset.filename.lastIndexOf(".")) + ".jpg");

            // otherwise we've to display a standard image
            var extensions = ['ai', 'eps', 'indd', 'pdf', 'psd', 'tiff'];

            if(extensions.indexOf(ext) > -1) {
                return require('../../../assets/img/fileTypes/datei-'+ext+'.png');
            }

        }

    }


}

</script>

<style>
    .contentBody p {
        margin: 0 0 1rem 0 !important;
    }
    .contentBody ul {
        list-style: disc;
        list-style-position: outside;
        margin: .5rem 0 .5rem 1rem;
    }
    .contentBody ul li {
        margin-bottom: .2rem;
    }
</style>


<style scoped>

    .propInner {
        position: relative;
    }
    .contentBody {
        display: inline;
        word-wrap: break-word;
        font-family: inherit;
        min-height: 20%;
        max-height: 45%;
        margin: 0 0 5% 0;
        overflow: hidden;
    }

    h1.title {
        font-weight: 700 !important;
        margin-bottom: 2% !important;
    }
    h2.subtitle {
        font-size: 110%;
        line-height: 115%;
        margin-bottom: 3% !important;
    }
    .leadin {

    }
    .richTextImg {
        width: 35%;
        margin: 0 1% 0 0;
    }

    .productBox {
        position: relative;
        padding: 1%;
        white-space: normal;
        margin: 0 0 0 1%;
        width: 40%;
        height: auto;
        border: 1px dotted #aaa;
        text-align: center;
    }
    .productBox .productBoxHeader {
        position: absolute;
        z-index: 2;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: -5%;
        width: auto;
        text-align: center;
    }
    .productBox .productBoxHeader span {
        margin: 0 auto;
        width: auto;
        background: #fff;
        font-size: 100%;
        font-weight: normal;
        text-transform: uppercase;
        padding: 0 4px;
    }
    .productBoxImage {
        width: 50%;
        margin: 0 auto;
    }
    .productBoxImage img {
        /*width: 50%;*/
        margin: 0 auto;
    }
    .productBox .productBoxHeadline {
        display: block;
        font-size: 80%;
        font-weight: bold;
        font-style:italic;
    }
    .productBox .productBoxType {
        display: block;
        text-align: center;
        line-height: 80%;
    }
    .productBox .productBoxType span {
        position: relative;
        font-size: 60%;
        display: inline;
        text-transform: uppercase;
        text-align: center;
        padding-left: 1.2em;
    }
    .productBox .productBoxType > span::before {
        content: '';
        position: absolute;
        border-color: inherit;
        border-width: .15em;
        border-style: solid;
        border-radius: 50%;
        border-color: #333;
        left: 0;
        top: .2em;
        width: .8em;
        height: 0;
        padding-top: .5em;
        text-align: center;
    }
    .productBox .productBoxText {
        font-size: 80%;
    }
    .productBox .productBoxTitle {
        display: inline-block;
        font-size: 80%;
        margin: 0 !important;
    }
</style>
